export const AUTH_KEYS = {
  returnUrl: "returnUrl"
} as const;
